<div class="flex flex-row justify-center">
    <div #svgContainer></div>
    <span *ngIf="errorMessage">
        {{ errorMessage }}
    </span>
</div>
